import Component from "@ember/component"
import { computed, get } from "@ember/object"
import _ from "lodash"
export default class CourseTimelineDatesOff extends Component.extend() {
  @computed("dates")
  get datesOff() {
    return _.filter(get(this, "dates"), (date) => date.isOff === true)
  }
}
